import axios from 'axios';
import { store } from '../index';
import _ from 'lodash';
import packageJson from "../../package.json";

const ClientVersion = packageJson.version;

const baseUrl = __API__;
const clientVersion = ClientVersion;
const urlApi = `${baseUrl}/API`;
const isProducao = __PRODUCAO__;
const buildTime = __BUILDTIME__;
const terminal = __TERMINAL__;
const hrefDestinosZip = 'http://hml.teconline.com.br/Terminais/Documentos/Tecon%20Rio%20Grande%20-%20Lista%20Destino%20Final.zip';
const orcamentoImpRig = 'https://atendimento.teconline.com.br/hc/pt-br/articles/360033779311-Or%C3%A7amento-de-Importa%C3%A7%C3%A3o';
const ArtemisCaisUrl = __ARTEMISCAISURL__;

const http = chooseApi();

function chooseApi() {
  process.env.rig = terminal === 'RIG';
  process.env.ssa = !process.env.rig;
  return axios.create({
    baseURL: urlApi
  });
}

export { isProducao, http, baseUrl, urlApi, buildTime, hrefDestinosZip, terminal,clientVersion,ArtemisCaisUrl };


// WEBPACK FOOTER //
// ./src/config/Constantes.js